import React from 'react';
import './Footer.css';
import { FaFacebook, FaInstagram, FaLinkedin, FaTelegram } from 'react-icons/fa';
import { BsTwitterX } from "react-icons/bs";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-section brand">
          <h2 className="logofooter" style={{ marginBottom: '1.5rem' }}>
            <img
              src={require('../images/logo-cigisdacolor.png')}
              alt="CIGSIDA Logo"
              style={{ height: '110px', marginBottom: '1rem' }}
            />
          </h2>
          <p>
            le congrès International sur la Gouvernance Sécuritaire, l'Innovation et le Développement en Afrique
          </p>
          <div className="socials">
            <a href="https://www.facebook.com/profile.php?id=61575151404825" aria-label="Facebook"><FaFacebook size={24} /></a>
            <a href="https://www.instagram.com/cigsida2025/?igsh=MWlkeWMwa2g5a2ZoYQ%3D%3D#" aria-label="Instagram"><FaInstagram size={24} /></a>
            <a href="https://ma.linkedin.com/in/congr%C3%A8s-international-gsida-965b9a35a?trk=public_post_feed-actor-name" aria-label="LinkedIn"><FaLinkedin size={24} /></a>
            <a href="#" aria-label="Telegram"><FaTelegram size={24} /></a>
            <a href="https://x.com/cigsida2025" aria-label="X"><BsTwitterX size={24} /></a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Navigation</h4>
          <ul>
           
         
            <li><a href="#speakers">Speakers</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Participation</h4>
          <ul>
            <li><a href="#participation">Participer</a></li>
            <li><a href="#NosFlyers">Flyers</a></li>
        
          </ul>
        </div>

        <div className="footer-section newsletter">
          <h4>Newsletter</h4>
          <p>Restez informé des dernières actualités et mises à jour de CIGSIDA.</p>
          <form>
            <input type="email" placeholder="Votre adresse email" />
            <button type="submit">S'abonner →</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} CIGSIDA. Tous droits réservés.</p>
        <div className="links">
          <a href="#confidentialite">Politique de confidentialité</a>
          <a href="#conditions">Conditions d'utilisation</a>
          <a href="#mentions">Mentions légales</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

